import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { joinClassnames } from 'helpers/classNames';

import { ISearchOverlayProps } from './SearchOverlay.definitions';

/** CSS import */
import Styles from './SearchOverlay.module.scss';

import SearchBar from '../../Molecules/SearchBar';
import PopularSearch from '../../Molecules/PopularSearch';
import RecentSearch from '../../Molecules/RecentSearch';
import SearchItems from '../../Molecules/SearchItems';
import useFetchKeywordSearch from 'Pages/Blog/Hooks/useFetchKeywordSearch';
import useDebounce from 'Pages/Home/Hooks/useDebounce';

const SearchOverlay: React.FC<ISearchOverlayProps> = ({
  isOpened,
  onClosed,
}: ISearchOverlayProps) => {
  const [isTyping, setIsTyping] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState('');

  const { fetchKeywordSearch, data, isFetching, totalArticles } =
    useFetchKeywordSearch();

  const onCloseOverlay = () => {
    onClosed();
    setIsTyping(false);
    setSearchValue('');
  };

  const renderSearchContent = React.useMemo(() => {
    if (isTyping) {
      return (
        <SearchItems
          data={data}
          isFetching={isFetching}
          keyword={searchValue}
          onClose={onCloseOverlay}
          totalArticles={totalArticles}
        />
      );
    }

    return (
      <>
        <PopularSearch />
        <RecentSearch />
      </>
    );
  }, [isTyping, data, isFetching]);

  const onSearch = (value: string) => {
    setSearchValue(value);
  };

  const debouncedKeyword = useDebounce(searchValue, 1750);

  React.useEffect(() => {
    if (debouncedKeyword.length > 0) {
      fetchKeywordSearch(debouncedKeyword, true);
    }
  }, [debouncedKeyword]);

  const onSetIsTyping = (value: boolean) => {
    setIsTyping(value);
  };

  const onCancel = () => {
    onClosed();
  };

  return (
    <div
      className={joinClassnames(
        Styles['overlay-wrapper'],
        isOpened
          ? Styles['overlay-wrapper--opened']
          : Styles['overlay-wrapper--closed'],
      )}
    >
      <div className={Styles['wrapper']}>
        <SearchBar
          onSearch={onSearch}
          setIsTyping={onSetIsTyping}
          onCancel={onCancel}
          searchValue={searchValue}
          onClose={onCloseOverlay}
          isOpened={isOpened}
        />
        {renderSearchContent}
      </div>
      <div
        className={joinClassnames(
          Styles['bg-overlay'],
          isOpened
            ? Styles['bg-overlay--opened']
            : Styles['bg-overlay--closed'],
        )}
        onClick={onCancel}
      />
    </div>
  );
};

export default SearchOverlay;
